import React, { forwardRef, useImperativeHandle, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import { XIcon } from '@phosphor-icons/react';
import Avatar from '@atoms/Avatar';

const PinnedTiles = forwardRef((props, ref) => {
  const MAX_CONTENT_LENGTH = 700;
  const [{ opacity, y }, api] = useSpring(() => ({
    from: { opacity: 0, y: window.innerHeight },
    to: { opacity: 1, y: 0 },
  }));

  const [comment, setComment] = React.useState<{ username: string; content: string, showUsername: boolean } | null>(null);

  const startAnimation = () => {
    api.start({ opacity: 1, y: -80 });
  };

  const closeAnimation = () => {
    api.start({ opacity: 0, y: window.innerHeight });
    setTimeout(() => {
      setComment(null);
    }, 100);
  };

  useImperativeHandle(ref, () => ({
    showPinnedComment: (newComment: { username: string; content: string, showUsername: boolean }) => {
      setComment(newComment);
      startAnimation();
    },
    close: () => {
      closeAnimation();
    },
    isOpen: () => {
      return comment !== null;
    },
    getComment: () => {
      return comment;
    },
  }));

  useEffect(() => {
    if (comment) {
      startAnimation();
    }
  }, [comment]);

  if (!comment) return null;

  const truncateContent = (content: string, maxLength: number) => {
    return content.length > maxLength ? content.slice(0, maxLength) + '...' : content;
  };
  return (
    <animated.div
      style={{ opacity, y }}
      className="w-[768px] h-auto absolute bottom-0 mx-auto left-0 right-0 rounded-2xl bg-white z-50 gap-4 flex items-start shadow-lg "
    >
      <div className='relative p-6 w-full '>

        <div className="h-full flex flex-col gap-4 justify-start w-[90%] overflow-hidden break-words">
          <p className="text-4xl w-full font-Inter text-gray-900 font-normal whitespace-normal">
            {truncateContent(comment?.content, MAX_CONTENT_LENGTH)}
          </p>
          {comment?.showUsername && (
            <div className="flex items-center gap-2">
              <Avatar isProfile staticColor="bg-grey-500" name={comment?.username || ''} />
              <p className="text-sm text-gray-900">{truncateContent(comment?.username, 30) || ''}</p>
            </div>
          )}
        </div>
        <button
          onClick={closeAnimation}
          className="p-2 text-grey-900 rounded-full bg-grey-100 h-7 min-w-7 flex items-center justify-center absolute top-3 right-3"
        >
          <XIcon />
        </button>
      </div>
    </animated.div>
  );
});

export default PinnedTiles;
